import React, { Component } from 'react';
import { Form, Input, Button } from 'reactstrap';
import { toast } from 'react-toastify';

import firebase from '../../firebase';
import TenantAdminPage from '../hocs/TenantAdminPage';
import { texts } from '../../config';

const db = firebase.firestore();
const tenantsRef = db.collection('tenants');

export default TenantAdminPage(class TenantAdminTableTypes extends Component {
  constructor() {
    super();
    this.state = {
      newTableType: ''
    };
  }
  componentDidMount() {
    this.listenTableTypes();
  }
  listenTableTypes() {
    const { match: { params: { slug } } } = this.props;
    tenantsRef
      .doc(slug)
      .collection('tableTypes')
      .orderBy('createdAt')
      .onSnapshot((snapshot) => {
        this.setState({ tableTypes: snapshot.docs.map(_ => ({ ..._.data(), id: _.id })) });
      });
  }
  clear = () => {
    this.setState({ newTableType: '' });
  }
  onSubmit = (event) => {
    event.preventDefault();
    const { tenant: { tableTypes = [] }, match: { params: { slug } } } = this.props;
    const { newTableType } = this.state;
    if (!newTableType) return;
    tenantsRef
      .doc(slug)
      .collection('tableTypes')
      .add({ name: newTableType, createdAt: new Date() })
      .then(this.clear)
      .then(() => toast.success('追加しました'));
  }
  delete = (id) => {
    if (!window.confirm('本当に削除しますか？')) return;
    const { match: { params: { slug } } } = this.props;
    tenantsRef
      .doc(slug)
      .collection('tableTypes')
      .doc(id)
      .delete()
      .then(() => toast.success('削除しました'));
  }
  onChangeTableType = ({ target: { value } }) => {
    this.setState({ newTableType: value });
  }
  render() {
    const { match: { params: { slug } } } = this.props;
    const { newTableType, tableTypes } = this.state;
    return (
      <div className="admin-tenants">
        <div className="d-flex justify-content-center mb-3">
          <h4>テーブルタイプ設定</h4>
        </div>
        <Form className="d-flex justify-content-end" onSubmit={this.onSubmit}>
          <Input className="mr-2" style={{ width: '200px' }} value={newTableType} onChange={this.onChangeTableType} />
          <Button type="submit" color="primary" disabled={!newTableType}>
            <span className="fas fa-plus mr-1" />
            追加
          </Button>
        </Form>
        <table className="table mt-5">
          <tbody>
            {
              (tableTypes || []).map(({ name, id }) => {
                return (
                  <tr key={id}>
                    <td>
                      {name}
                    </td>
                    <td>
                      <Button color="danger" onClick={this.delete.bind(this, id)}>
                        <span className="fas fa-trash mr-1" />
                        削除
                      </Button>
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
    );
  }
});
